import React, {PropTypes} from "react";
import { Link } from "react-router";
import Scroll from 'react-scroll';

function handleClick() {
	const scroll = Scroll.animateScroll;
	scroll.scrollTo(80);
}

function NavButton(props) {
	const { path, name } = {...props};
	return (
		<Link to={ path } onClick={ handleClick } >
			{ name }{ props.children }
		</Link>
	)
}

NavButton.propTypes = {
	path: PropTypes.string.isRequired,
	name: PropTypes.string
}

export default NavButton;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/NavButton.jsx
 **/